import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { isUndefined } from 'lodash'
import { Link } from 'react-router'
import AzureOAuthLogin from './AzureOAuthLogin'
import TestOAuthLogin from './TestOAuthLogin'
import CredentialsLogin from './CredentialsLogin'
import { loadConfigs, createOAuthSession, createCredentialsSession } from '../../actions/Login'
import alert from '../../alert'

class Login extends Component {
  static propTypes = {
    loadConfigs: PropTypes.func.isRequired,
    createCredentialsSession: PropTypes.func.isRequired,
    createOAuthSession: PropTypes.func.isRequired,
    clientId: PropTypes.string,
    sessionError: PropTypes.string,
    oauthError: PropTypes.string
  }

  constructor(props) {
    super(props)

    this.createCredentialsSession = this.createCredentialsSession.bind(this)
    this.createOAuthSession = this.createOAuthSession.bind(this)
  }

  componentDidMount() {
    this.props.loadConfigs()
  }

  get redirectPathname() {
    return window.location.pathname
  }

  createCredentialsSession(username, password) {
    this.props.createCredentialsSession(username, password, this.redirectPathname)
  }

  createOAuthSession(token) {
    this.props.createOAuthSession(token, this.redirectPathname)
  }

  loginComponents() {
    const loginComponents = []

    loginComponents.push(
      <CredentialsLogin
        key="credentials"
        createCredentialsSession={this.createCredentialsSession}
        error={this.props.sessionError}
      />
    )
    loginComponents.push(
      <Link
        key="forgotPassword"
        to="/forgot_password"
        title="Forgot Password"
        className="primary-link"
      >
        Forgot Password?
      </Link>
    )

    if (!isUndefined(this.props.clientId)) {
      const OAuthComponent = process.env.REACT_APP_ACCEPTANCE_TESTING === 'true' ? TestOAuthLogin : AzureOAuthLogin

      loginComponents.push(
        <OAuthComponent
          key="oauth"
          createOAuthSession={this.createOAuthSession}
          clientId={this.props.clientId}
        />
      )
    }

    return loginComponents
  }

  render() {
    const { oauthError } = this.props

    if (typeof oauthError !== 'undefined') {
      alert(oauthError)
    }

    return (
      <div className="login-container">
        {this.loginComponents()}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  sessionError: state.login.session.credentialsError,
  oauthError: state.login.oauthConfig.error || state.login.session.oauthError,
  clientId: state.login.oauthConfig.clientId
})

const mapDispatchToProps = (dispatch) => bindActionCreators({
  loadConfigs,
  createCredentialsSession,
  createOAuthSession
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Login)
